import { MessageModel } from '@/models/message.model'
import { SendMessageResponse } from '@/redux/message/sagas/createMessageSaga/http/message/types'
import { isAfter } from 'date-fns'

export function isMessageOlderThan15Minutes(message: MessageModel) {
  const messageDate = new Date(message?.createdAt || message?.moment || message?.momment)
  const fifteenMinutesAgo = new Date(new Date().getTime() - 15 * 60 * 1000)
  return isAfter(fifteenMinutesAgo, messageDate)
}

export function buildUnOfficialMessage(
  message: MessageModel,
  sendUnOfficialMessage: SendMessageResponse
): MessageModel[] {
  if (sendUnOfficialMessage.messageId) {
    const moment = sendUnOfficialMessage.messageContent?.[0]?.moment

    return [
      {
        ...message,
        messageId: sendUnOfficialMessage.messageId,
        moment,
        momment: moment,
        createdAt: moment || new Date().getTime()
      }
    ]
  } else {
    const sendedMessages: MessageModel[] = sendUnOfficialMessage.messageContent
      .map(messageC => {
        return {
          ...message,
          messageId: messageC.messageId,
          messageText: messageC?.message || '',
          moment: messageC.moment,
          momment: messageC.moment,
          createdAt: messageC.moment || new Date().getTime(),
          audio: messageC?.type === 'audio' ? { audioUrl: messageC.fileUrl, mimeType: messageC.mimeType } : null,
          image:
            messageC?.type === 'image'
              ? {
                  mimeType: messageC.mimeType || '',
                  imageUrl: messageC.fileUrl || '',
                  caption: messageC.caption || ''
                }
              : null,
          video:
            messageC?.type === 'video'
              ? { videoUrl: messageC.fileUrl, mimeType: messageC.mimeType, caption: messageC?.caption || '' }
              : null,
          document:
            messageC?.type === 'document'
              ? { documentUrl: messageC.fileUrl, mimeType: messageC.mimeType, fileName: messageC?.fileName || '' }
              : null,
          file: '' as any,
          files: null
        }
      })
      .sort((a, b) => b.momment - a.momment)

    return sendedMessages
  }
}
